module.exports = __webpack_public_path__ + "static/img/indexIntroArea03.f7ed317.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/indexIntroArea03.jpg
// module id = xoDk
// module chunks = 3